import { Logo } from "./Navbar";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#2E3336] py-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
        <Logo />
        <nav className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs uppercase tracking-widest text-white/50" data-testid="footer-nav">
          <a href="#services" className="hover:text-[#6EB000] transition-colors">Services</a>
          <a href="#apropos" className="hover:text-[#6EB000] transition-colors">À propos</a>
          <a href="#contact" className="hover:text-[#6EB000] transition-colors">Contact</a>
          <a href="/mentions-legales" className="hover:text-[#6EB000] transition-colors">Mentions légales</a>
          <a href="/politique-confidentialite" className="hover:text-[#6EB000] transition-colors">Confidentialité</a>
        </nav>
        <div className="text-center sm:text-right" data-testid="footer-legal">
          <p className="text-xs text-white/40">SIRET : 504 715 137 00072</p>
          <p className="text-xs text-white/40 mt-1">© {new Date().getFullYear()} NBPerf — www.nbperformance.fr</p>
        </div>
      </div>
    </footer>
  );
}
